import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import WhenToConsult from './components/WhenToConsult/WhenToConsult';
import Booking from './components/Booking/Booking';
import About from './components/About/About';
import Footer from './components/Footer';
import './App.css';

import RevealOnScroll from './components/RevealOnScroll/RevealOnScroll';

function App() {
  return (
    <div className="App">
      <Navbar />
      <RevealOnScroll>
        <Hero />
      </RevealOnScroll>
      <RevealOnScroll>
        <WhenToConsult />
      </RevealOnScroll>
      <RevealOnScroll>
        <Booking />
      </RevealOnScroll>
      <RevealOnScroll>
        <About />
      </RevealOnScroll>
      <Footer />
    </div>
  );
}

export default App;
